import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from '../../providers/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';

@Component({
  selector: 'app-activacion',
  templateUrl: './activacion.component.html',
  styleUrls: ['./activacion.component.css']
})
export class ActivacionComponent implements OnInit, OnDestroy {
  successMessage: string;
  errorMessage: string;
  activacionExitosa = false;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: Auth,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.spinner.show();
    const token = this.route.snapshot.params['token'];

    if (!token) {
      this.errorMessage = 'Token de activación no encontrado.';
      this.spinner.hide();
      return;
    }

    this.auth.activateAccount(token)
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.activacionExitosa = true;
          this.successMessage = '¡Cuenta activada exitosamente! Ya puede iniciar sesión.';
          setTimeout(() => this.successMessage = '', 10000);
        },
        (err: any) => {
          this.spinner.hide();
          this.activacionExitosa = false;
          this.errorMessage = err.error && err.error.message
            ? err.error.message
            : 'El enlace de activación no es válido o ha expirado. Intente registrarse nuevamente.';
          setTimeout(() => this.errorMessage = '', 10000);
        }
      );
  }

  irALogin() {
    this.router.navigate(['login']);
  }

  irARegistro() {
    this.router.navigate(['signup']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/activacion/activacion.component.ts